import switchContainer from './switchContainer';
import user from './user';
import oss from './oss';

export default [switchContainer, user, oss];



// WEBPACK FOOTER //
// ./src/models/common/index.js